import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";

import LoginPage from "../auth/LoginPage";
import RegisterPage from "../auth/RegisterPage";
import ForgotPassword from "../auth/password/ForgotPassword";
import ParentResetPassword from "../auth/password/parent/ParentResetPassword";
import ResetPassword from "../auth/password/reset/ResetPassword";
import AuthLayout from "../layout/AuthLayout";
import { selectUser } from "../redux/slices/auth.slice";

const AuthRoutes = () => {
  const navigate = useNavigate();

  const user = useSelector(selectUser);

  useEffect(() => {
    if (user) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  return (
    <AuthLayout>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="password/forgot-password" element={<ForgotPassword />} />
        <Route path="password/reset/:token" element={<ResetPassword />} />
        <Route path="password/parent/:phone" element={<ParentResetPassword />} />
      </Routes>
    </AuthLayout>
  );
};

export default AuthRoutes;
